import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const MyAuthContext = createContext(null);

export function MyAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkSession = useCallback(async () => {
    try {
      const res = await fetch('/api/my/auth/me', { credentials: 'include' });
      if (res.ok) {
        const data = await res.json();
        setUser(data);
      } else {
        setUser(null);
      }
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const login = useCallback((userData) => {
    setUser(userData);
  }, []);

  const logout = useCallback(async () => {
    try {
      await fetch('/api/my/auth/logout', {
        method: 'POST',
        credentials: 'include',
      });
    } catch {}
    setUser(null);
  }, []);

  return (
    <MyAuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </MyAuthContext.Provider>
  );
}

export function useMyAuth() {
  const ctx = useContext(MyAuthContext);
  if (!ctx) throw new Error('useMyAuth must be used within MyAuthProvider');
  return ctx;
}
